module.exports = __webpack_public_path__ + "public/static/aboutBgOne.svg?4d0cc18b";